import $ from 'jquery'

let PassworChange = {
  /**
   * Menu component
   *
   * Adds a sidebar menu to the document
   */
  init: function () {
    $('body').addClass('passwordchange')
  }
}

export default PassworChange



// WEBPACK FOOTER //
// ./src/core/PasswordChange.js